exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Menu-module__wrapper___1nrcc{position:fixed;top:2em;right:2em;display:grid;gap:2em;z-index:10}.Menu-module__wrapper___1nrcc .Menu-module__menu___qKL3e{position:relative;background-color:#181818;padding:1em;border-radius:15px;display:grid;justify-content:center;gap:1em}.Menu-module__wrapper___1nrcc .Menu-module__menu___qKL3e button{width:100%;height:100%}.Menu-module__wrapper___1nrcc .Menu-module__menu___qKL3e button img{width:100%}.Menu-module__wrapper___1nrcc hr{color:grey;width:100%}", ""]);

// exports
exports.locals = {
	"wrapper": "Menu-module__wrapper___1nrcc",
	"menu": "Menu-module__menu___qKL3e"
};